import PropTypes from "prop-types";

const _Padding = PropTypes.shape({
  display_padding: PropTypes.bool,
  padding_top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

// Full Text prop types
export const _Text = PropTypes.shape({
  display_text_order: PropTypes.bool,
  display_text: PropTypes.bool,
  text_content: PropTypes.string,
  text_order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text_padding: _Padding,
});

export const TextPropTypes = _Text;
